import { Component, OnInit, Input } from '@angular/core';
import { Course } from '../../../objects/course';

@Component({
  selector: 's18-scoreboard-header',
  templateUrl: './scoreboard-header.component.html',
  styleUrls: ['./scoreboard-header.component.scss']
})
export class ScoreboardHeaderComponent implements OnInit {

  @Input() courseInfo : Course;
  @Input() showScoresOnMobile : boolean
  
  constructor() { }

  ngOnInit() {
  }

  showOnMobile(): boolean {
    return this.showScoresOnMobile;
  } 

}
